import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SettingsChangeStripeTerminalReaderPage } from 'src/app/modals/settings-change-stripe-terminal-reader/settings-change-stripe-terminal-reader.page';

const routes: Routes = [
  {
    path: '',
    component: SettingsChangeStripeTerminalReaderPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SettingsChangeStripeTerminalReaderPage]
})
export class SettingsChangeStripeTerminalReaderPageModule {}
